module.exports = __webpack_public_path__ + "img/case-yifa.506776dc.png";